'use strict';

/**
 *
 * @name: joinUs
 *
 */

import DirectiveTemplate from './nn-picked-contributors.directive.html';
import './nn-picked-contributors.directive.scss';

function NnPickedContributorsDirective(transObject) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope) {

      /*
       *
       * @CONFIG
       *
       */

      scope.item = scope.content();
      scope.contributors = _getContributors();
      scope.loaded = true;
      scope.swiperOptions = {
        spaceBetween: 20
      }
      scope.isGridView = scope.item.jsonData.viewType === 'grid'

      /*
       *
       * @PRIVATE
       *
       */

      function _getContributors(){
        var contributors = scope.item && scope.item.jsonData && scope.item.jsonData.contributors;

        if(!contributors || !contributors.length){
          return null;
        }

        return contributors.map(function(item){
          transObject.trueSlug(item);
          return item;
        });
      }

      /*
       *
       * @INIT
       *
       */
    }
  };
}

export default NnPickedContributorsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-picked-contributors/nn-picked-contributors.directive.js